const _ = require('lodash');

/**
 *
 * @param formValues form values
 * @param context.controlName property to check
 */
function validate(formValues, context) {
  const fa = formValues;
  let values = fa;

  const {
    controlName,
    extraFilter = null,
    exceptions = [],
  } = context;

  if (extraFilter) {
    values = _.filter(values, extraFilter);
  }
  values = _.map(values, (v) => v[controlName]);
  values = _.filter(values, (v) => !!v);

  if (exceptions && exceptions.length > 0) {
    const exceptionValues = _.map(exceptions, 'name');
    const maxReached = _.some(exceptions, (e) => (
      _.filter(values, (v) => v === e.name).length > e.maxCount));
    if (maxReached) {
      return 'no-same-values';
    }
    // remove the exception values from the current list
    values = _.filter(values, (v) => !exceptionValues.includes(v));
    // merge max unique values based on exception value
  }
  const uniqueValues = _.uniq(values);
  const result = uniqueValues.length !== values.length ? 'no-same-values' : null;
  return Promise.resolve(result ? 'no-same-values' : null);
}

module.exports = validate;
